// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-file-container{
    width:100%;
}
.support-each-file-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width:100%;
    height:auto;
    margin-top:1rem;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(239, 241, 243);
    padding:0.5rem;
    border-radius:0.25rem;
}
.supports-file-preview-image{
    display: flex;
    flex-direction: column;
    width:100%;
    height:auto;

}
.pdf-doc-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    /* justify-content: space-between; */
    gap:0.5rem;
}
.pdf-doc-preview-image{
    width:50px;
    height:50px;
}
.upload-files-container-uploader{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width:100%;
    padding:0.5rem;
}
.upload-files-not-open{
    display:none;
}
.support-files-upload-container{
    padding:0.5rem;
}
.support-ticket-upload-btn{
    width:100%;
}
.support-files-download-button{
    border:none;
    display:flex;
    align-items: center;
    background-color: transparent;
    justify-content: center;
    margin-left:2rem;
}
.support-files-download-icon{
    color: rgb(64, 64, 242);
    width:1.5rem;
    height: 1.5rem;
}
.file-preview-title{
    word-wrap: break-word;
    position:absolute;
    bottom:0%;
    width:100%;
    font-size:12px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow:hidden;
    padding:0.125rem;
}
@media only screen and (max-width: 1281px) and (min-width: 720px) {
    .support-files-download-button{
        margin-left:1rem;
    }
  
  }
  
  @media only screen and (max-width: 1650px) and (min-width: 1282px) {
    .support-files-download-button{
        margin-left:2rem;
    }
  
  }
  
  
  
  @media only screen and (max-width: 719px) and (min-width: 300px) {
    .support-files-download-button{
        margin-left:1rem;
    }
  
  }
  @media only screen and (max-height: 700px) and (min-height: 300px) {
    .support-files-download-button{
        margin-left:0.5rem;
    }
    
    }
    @media only screen and (max-width: 1900px) and (min-width: 1700px) {
        .support-files-download-button{
            margin-left:3rem;
        }
    
}`, "",{"version":3,"sources":["webpack://./src/pages/support/Comments/Files/Files.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,eAAe;IACf,oCAAoC;IACpC,oCAAoC;IACpC,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,WAAW;;AAEf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,oCAAoC;IACpC,UAAU;AACd;AACA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;AAClB;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI;QACI,gBAAgB;IACpB;;EAEF;;EAEA;IACE;QACI,gBAAgB;IACpB;;EAEF;;;;EAIA;IACE;QACI,gBAAgB;IACpB;;EAEF;EACA;IACE;QACI,kBAAkB;IACtB;;IAEA;IACA;QACI;YACI,gBAAgB;QACpB;;AAER","sourcesContent":[".upload-file-container{\r\n    width:100%;\r\n}\r\n.support-each-file-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width:100%;\r\n    height:auto;\r\n    margin-top:1rem;\r\n    background-color: rgb(255, 255, 255);\r\n    border: 1px solid rgb(239, 241, 243);\r\n    padding:0.5rem;\r\n    border-radius:0.25rem;\r\n}\r\n.supports-file-preview-image{\r\n    display: flex;\r\n    flex-direction: column;\r\n    width:100%;\r\n    height:auto;\r\n\r\n}\r\n.pdf-doc-container{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    /* justify-content: space-between; */\r\n    gap:0.5rem;\r\n}\r\n.pdf-doc-preview-image{\r\n    width:50px;\r\n    height:50px;\r\n}\r\n.upload-files-container-uploader{\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    width:100%;\r\n    padding:0.5rem;\r\n}\r\n.upload-files-not-open{\r\n    display:none;\r\n}\r\n.support-files-upload-container{\r\n    padding:0.5rem;\r\n}\r\n.support-ticket-upload-btn{\r\n    width:100%;\r\n}\r\n.support-files-download-button{\r\n    border:none;\r\n    display:flex;\r\n    align-items: center;\r\n    background-color: transparent;\r\n    justify-content: center;\r\n    margin-left:2rem;\r\n}\r\n.support-files-download-icon{\r\n    color: rgb(64, 64, 242);\r\n    width:1.5rem;\r\n    height: 1.5rem;\r\n}\r\n.file-preview-title{\r\n    word-wrap: break-word;\r\n    position:absolute;\r\n    bottom:0%;\r\n    width:100%;\r\n    font-size:12px;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    overflow:hidden;\r\n    padding:0.125rem;\r\n}\r\n@media only screen and (max-width: 1281px) and (min-width: 720px) {\r\n    .support-files-download-button{\r\n        margin-left:1rem;\r\n    }\r\n  \r\n  }\r\n  \r\n  @media only screen and (max-width: 1650px) and (min-width: 1282px) {\r\n    .support-files-download-button{\r\n        margin-left:2rem;\r\n    }\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  @media only screen and (max-width: 719px) and (min-width: 300px) {\r\n    .support-files-download-button{\r\n        margin-left:1rem;\r\n    }\r\n  \r\n  }\r\n  @media only screen and (max-height: 700px) and (min-height: 300px) {\r\n    .support-files-download-button{\r\n        margin-left:0.5rem;\r\n    }\r\n    \r\n    }\r\n    @media only screen and (max-width: 1900px) and (min-width: 1700px) {\r\n        .support-files-download-button{\r\n            margin-left:3rem;\r\n        }\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
